var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fontStyleSet"},[_c('div',{staticClass:"leftSlider"},[_c('fontLeft',{ref:"fontSetLeft",on:{"setCurrentFont":_vm.setCurrentFont}})],1),_c('div',{staticClass:"rightSlider"},[_c('fontRight',{ref:"fontSetRight",on:{"refreshLeft":_vm.refreshLeft}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }